export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-current-cart').forEach((el) => {
      let full_item = el.dataset.fullItem || 'false'
      fetch('/ec/cart.json?full_item=' + full_item).then((res) => {
        res.json().then((data) => {
          // trigger event 'odims:cart:current'
          document.dispatchEvent(
            new CustomEvent('odims:cart:current', {
              detail: data,
            })
          )
        })
      })
    })
  })
})()
